export interface IExitPopUp {
  enabled: boolean;
  coupon: ICoupon;
  timer: ITimer;
  button: IButton;
  media: IMedia;
}

export interface ICoupon {
  enabled: boolean;
  token?: string;
  description: string;
  type: enTypeCupom;
  value: number;
}

export enum enTypeCupom {
  PERCENTAGE = 0,
  VALUE = 1
}

export interface ITimer {
  time: number;
  enabled: boolean;
  theme: ITimerTheme;
}

export interface IButton {
  enabled: boolean;
  theme: IButtonTheme;
}

export interface IMedia {
  image?: string;
  video?: string;
}

export interface ITimerTheme {
  title: string;
  titleColor: string;
  titleSize: string;
  backgroundColor: string;
}

export interface IButtonTheme {
  text: string;
  textColor: string;
  textSize: number;
  backgroundColor: string;
  backgroundColorHover: string;
}
